export default "__VITE_ASSET__e53def6d__"